export default ({ request }) => ({
  mrpProductStockInListApi(data = {}) {
    return request({
      url: '/factory/mrp/product/stock/in/list',
      method: 'post',
      data,
    })
  },
  mrpProductStockInSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/product/stock/in/save',
      method: 'post',
      data,
    })
  },
  mrpProductStockInAuditApi(data = {}) {
    return request({
      url: '/factory/mrp/product/stock/in/audit',
      method: 'post',
      data,
    })
  },
  mrpProductStockInDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/product/stock/in/detail',
      method: 'post',
      data,
    })
  },
  mrpProductStockInDelApi(data = {}) {
    return request({
      url: '/factory/mrp/product/stock/in/del',
      method: 'post',
      data,
    })
  },
})
